// src/random/Types.ts
var defaultRandom = Math.random;

export {
  defaultRandom
};
//# sourceMappingURL=chunk-5VWJ6TUI.js.map